  /*
  * tw-custom-pdp-atc.js
  *
  * Loaded only from `sections/tw-custom-main-product.liquid`. Restores the
  * "Add to cart | {price}" markup after `variants.js` replaces the submit
  * label with plain text — no edits to global theme assets.
  *
  * Hooks: `variantChangeEnd` (from `<variant-options>`), MutationObserver on
  * `[name="add"] > span`, then calls `window.twCustomPdpV2.refreshAtcPrice()`
  * from `tw-recharge-overrides-v2.js`.
  */

  (function () {
    'use strict';

    var _debounceTimer = null;

    /**
     * @returns {NodeListOf<Element>}
     */
    function getScopedProductForms() {
      return document.querySelectorAll('product-form[data-tw-atc-inline]');
    }

    /**
     * @param {HTMLElement} addButtonText
     */
    function rebuildAtcMarkup(addButtonText) {
      var wrap = addButtonText.closest('product-form');
      var extraMeta = wrap ? wrap.getAttribute('data-tw-atc-extra') || '' : '';
      var vs = window.variantStrings || {};
      var ctaLabel = vs.addToCart || 'Add to cart';

      addButtonText.textContent = '';
      var inner = document.createElement('span');
      inner.className = 'tw-atc-btn__inner tw-atc-btn__inner--no-price';
      var cta = document.createElement('span');
      cta.className = 'tw-atc-btn__cta';
      cta.textContent = ctaLabel;
      var sep = document.createElement('span');
      sep.className = 'tw-atc-btn__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '|';
      var price = document.createElement('span');
      price.setAttribute('data-tw-atc-price', '');
      inner.appendChild(cta);
      inner.appendChild(sep);
      inner.appendChild(price);
      addButtonText.appendChild(inner);

      if (extraMeta) {
        var ex = document.createElement('span');
        ex.className = 'tw-atc-btn__extra';
        ex.textContent = extraMeta;
        addButtonText.appendChild(ex);
      }
    }

    /**
     * @param {HTMLButtonElement} btn
     * @param {HTMLElement} span
     * @returns {boolean}
     */
    function shouldRestoreMarkup(btn, span) {
      if (!btn || !span) return false;
      if (btn.disabled) return false;
      if (span.querySelector('[data-tw-atc-price]')) return false;

      var vs = window.variantStrings || {};
      var t = (span.textContent || '').trim();
      if (vs.soldOut && t === vs.soldOut) return false;
      if (vs.unavailable && t === vs.unavailable) return false;

      return true;
    }

    function ensureMainAtcMarkup() {
      getScopedProductForms().forEach(function (pf) {
        var btn = pf.querySelector('[name="add"]');
        var span = pf.querySelector('[name="add"] > span');
        if (!shouldRestoreMarkup(btn, span)) return;
        rebuildAtcMarkup(span);
      });
    }

    function refreshPrices() {
      if (
        window.twCustomPdpV2 &&
        typeof window.twCustomPdpV2.refreshAtcPrice === 'function'
      ) {
        window.twCustomPdpV2.refreshAtcPrice();
      }
    }

    function scheduleSync() {
      clearTimeout(_debounceTimer);
      _debounceTimer = setTimeout(function () {
        ensureMainAtcMarkup();
        refreshPrices();
      }, 15);
    }

    function bindMutationObservers() {
      getScopedProductForms().forEach(function (pf) {
        var span = pf.querySelector('[name="add"] > span');
        if (!span || span.__twCustomPdpAtcBound) return;
        span.__twCustomPdpAtcBound = true;

        var mo = new MutationObserver(function () {
          scheduleSync();
        });
        mo.observe(span, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      });
    }

    function boot() {
      scheduleSync();
      bindMutationObservers();
      document.addEventListener('variantChangeEnd', scheduleSync);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
